
export default function SucursalesGrid({ sucursales, openModal }) {
  return (
    <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-1 gap-4 w-full max-w-4xl mx-auto px-2">
      {sucursales.map((sucursal, index) => (
        <div
          key={index}
          className="bg-white p-4 rounded-xl shadow-md flex flex-col justify-between h-full"
        >
          <h3 className="text-base font-semibold text-center mb-2">
            {sucursal.nombre}
          </h3>
          <button
            onClick={() => openModal(sucursal)}
            className="mt-auto px-3 py-2 bg-blue-600 text-white text-sm rounded-lg hover:bg-blue-700 transition-colors"
          >
            Más Información
          </button>
        </div>
      ))}
    </div>

  );
}
